/* eslint-disable no-restricted-imports*/
import React from 'react';
import cn from 'classnames';
import MuiBadge, { BadgeProps as MuiBadgeProps } from '@mui/material/Badge';
import { Corner } from '../..';

export interface BadgeProps extends Omit<MuiBadgeProps, 'color'> {
  corner?: Corner;
  size?: 'small' | 'medium' | 'large';
  color?: MuiBadgeProps['color'] | 'inverse';
  edgeOverlapOutlineColor?: string;
}

const Badge = ({
  corner = 'pill',
  size = 'medium',
  edgeOverlapOutlineColor,
  ...props
}: BadgeProps) => {
  const isInverse = props.color === 'inverse';

  return (
    <MuiBadge
      {...props}
      color={isInverse ? undefined : props.color as MuiBadgeProps['color']}
      slotProps={{
        badge: {
          style: edgeOverlapOutlineColor ? {
            outline: `2px solid ${edgeOverlapOutlineColor}`,
            outlineOffset: -1,
          } : undefined,
          className: cn(
            props.className,
            `MuiBadge-size-${size}`,
            `MuiBadge-corner-${corner}`,
            { 'MuiBadge-inverse': isInverse },
            { 'MuiBadge-inline': !props.children },
          )
        }
      }}
    />
  );
};

export default Badge;